import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { Subscription } from 'rxjs';
import moment from 'moment';

@Component({
  selector: 'app-date-form-field',
  templateUrl: './date-form-field.component.html',
  styleUrls: ['./date-form-field.component.scss']
})
export class DateFormFieldComponent implements OnInit, OnDestroy {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;

  private subscription: Subscription;

  constructor() { }

  ngOnInit(): void {
    // Subscribe to value changes to format dates properly for submission
    if (this.parentGroup && this.formElement?.formControl) {
      const control = this.parentGroup.get(this.formElement.formControl);
      if (control) {
        this.subscription = control.valueChanges.subscribe(value => {
          if (value && moment.isMoment(value)) {
            // Ensure the date is stored in YYYY-MM-DD format to prevent timezone issues
            const formattedDate = value.format('YYYY-MM-DD');
            // Only update if the value is different to prevent infinite loop
            if (control.value.format('YYYY-MM-DD') !== formattedDate) {
              control.setValue(formattedDate, { emitEvent: false });
            }
          }
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
